/* 
 * Export component file to be used on project
*/

import RescheduleModal from './RescheduleModal.js'
export default RescheduleModal
